module.exports = __webpack_public_path__ + "static/ut-lite-beta-logo-9e414098db5c076e344a0bdc4e5c0f88.svg";